import type { TrendProps } from '../../core/components/single-value-renderer/components/trend/types/trend-props.js';

/** Slot for the Trend component */
export const Trend = (props: TrendProps) => null;
